export default __webpack_public_path__ + "locales/vi/MainBar.json?hash=cae04f2d8f6639519c5d4d8150f3e2a5";